import { fetchToken } from "../../../common/FetchCookie";
import { APPLICANTS, BASE_URL, EMPLOYER, JOBS } from "../../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${EMPLOYER}/v2/${JOBS}/${APPLICANTS}`;

export const fetchApplicantList = async (uuid) => {
  const url = `${API_BASE_URL}/${uuid}`;
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    return error
  }
};
